import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("app_token");
  console.log("Checking app_token:", token); // ✅ Should print on each route
  return token ? children : <Navigate to="/app-login" replace />;
};

export default PrivateRoute;
